import styled, { css } from 'vue-styled-components';
import { COLORS, BLUE, GRAY, square } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_CENTER_DIV,
    GRAY_100_SPAN,
    GRAY_100_DIV,
} from '@/styles/common.styled.component';
import { DropdownSearchLabel } from '@/components/Dashboard/common/WidgetSettingPanel/options/styles';

export const ComponentWrapper = styled(FLEX_COLUMN_DIV)`
    height: 100%;
    width: 100%;
`;

export const SearchWrapper = styled(DropdownSearchLabel)`
    margin: 0 0 13px 0;
    width: 100%;
    height: 40px;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;

    .search-input {
        width: 100%;
    }
`;

export const LoaderWrapper = styled(FLEX_CENTER_DIV)`
    width: 100%;
    height: 100%;
    min-height: 50px;
`;

export const ListWrapper = styled(FLEX_COLUMN_DIV, { marginBottom: Number })`
    overflow-y: auto;
    height: auto;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? `${marginBottom}px` : '20px'};
`;

export const ItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    selected: Boolean,
})`
    padding: 10px 16px;
    margin-bottom: 9px;
    border: 1px solid ${({ selected }) => (selected ? BLUE(60) : GRAY(20))};
    border-radius: 4px;
    cursor: pointer;
    justify-content: space-between;
`;

export const ItemSpan = styled(GRAY_100_SPAN)`
    font-size: 14px;
    margin-left: 7px;
`;

export const ConnectionLogo = styled.img`
    width: 24px;
    height: 24px;
`;

export const MainTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const LeftWrapper = styled(FLEX_COLUMN_DIV)`
    font-size: 20px;
    font-weight: 500;
    color: ${GRAY(100)};
`;

export const MainTitleTop = styled(FLEX_VERTICAL_CENTER_DIV)`
    color: ${GRAY(100)};

    & > a {
        height: 22px;
    }

    & svg {
        margin-right: 8px;
        &:hover {
            cursor: pointer;
        }
    }

    @media screen and (max-width: 400px) {
        font-size: 16px;
    }
`;

export const InputWrapper = styled(FLEX_COLUMN_DIV, { disabled: Boolean })`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .input-field {
        margin: 0 auto;
        width: 100%;
        & > input {
            max-width: unset;
            width: 100%;
            margin-left: unset;
        }
    }
    .checkbox-wrapper {
        justify-content: flex-end;
    }
    ${({ disabled }) =>
        disabled &&
        css`
            position: relative;
            &::after {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background: rgba(244, 246, 248, 0.5);
                cursor: not-allowed;
            }
        `}

    & .selected-box {
        max-width: 335px;
    }
`;

export const HelpText = styled(GRAY_100_SPAN)`
    font-size: 13px;
    margin-top: 4px;
    text-align: right;
    white-space: pre-line;
    word-break: break-word;
`;

export const InputTypeText = styled(GRAY_100_SPAN)`
    font-size: 13px;
    line-height: 2.5;
    vertical-align: middle;
`;

export const ChoiceWraper = styled.div`
    & .selected-box {
    }
`;

export const ItemLeftWrapper = styled(FLEX_VERTICAL_CENTER_DIV)``;

export const ItemRightWrapper = styled.div`
    & > svg {
        ${square(16)}
    }
`;

export const SpaceBetweenItemWrapper = styled(ItemWrapper, {
    isAuthorized: Boolean,
})`
    justify-content: space-between;
    ${({ isAuthorized }) =>
        !isAuthorized &&
        css`
            background: #eee;
        `}
`;

export const ConnectionNameWrapper = styled(FLEX_COLUMN_DIV)`
    & .created_at {
        font-size: 12px;
        color: ${GRAY(50)};
    }
`;

export const NewConnectionButton = styled.button`
    position: absolute;
    bottom: 24px;
    width: 90%;
    padding: 15px 24px;
    background: ${BLUE(60)};
    border-radius: 4px;
`;

export const NewConnectionText = styled.span`
    font-size: 16px;
    color: #fff;
    font-weight: 500;
`;

export const ErrorText = styled.span`
    display: block;
    font-size: 13px;
    color: ${COLORS['red-60']};
    margin-top: 4px;
    width: 100%;
    text-align: right;
`;

export const FormListWrapper = styled.div`
    width: 100%;
    & > :last-child {
        margin-bottom: 28px;
    }
`;

export const FormOptionWrapper = styled(FLEX_COLUMN_DIV)`
    width: 100%;
`;

export const FormOptionTitleWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    opened: Boolean,
})`
    border: 1px solid ${GRAY(20)};
    padding: 10px 16px;
    justify-content: space-between;
    width: 100%;

    border-radius: 4px 4px 0 0;
    cursor: pointer;
    & > span {
        color: ${GRAY(100)};
        font-weight: 500;
    }
    & > svg {
        ${square(16)}
        transform:${({ opened }) => (opened ? 'rotate(180deg)' : 'unset')}
    }
`;

export const FormOptionContetnWrapper = styled(FLEX_COLUMN_DIV)`
    padding: 12px;
    border-radius: 0 0 4px 4px;
    border: 1px solid ${GRAY(20)};
    border-top: unset;
    margin-bottom: 20px;
`;

export const DialogWrapper = styled(FLEX_COLUMN_DIV);

export const DialogText = styled(GRAY_100_SPAN)`
    display: block;
    white-space: pre-line;
`;

export const AnchorText = styled.span`
    font-weight: 500;
`;

export const GuideWrapper = styled.div`
    margin-bottom: 20px;
    cursor: pointer;
`;

export const FileConnectorGuide = styled(GRAY_100_DIV)`
    border: 1px solid ${GRAY(20)};
    padding: 16px;
    margin-bottom: 16px;
    font-size: 12px;
`;

export const FileConnectorSubGuide = styled(GRAY_100_DIV)`
    margin-bottom: 16px;
    font-size: 12px;
    text-align: right;
`;

export const CustomFieldPanelTrigger = styled.a`
    text-align: right;
    margin-top: 4px;
    font-size: 13px;
`;

export const FileTypeHint = styled.div`
    font-size: 12px;
    color: ${GRAY[600]};
    margin-top: 4px;
`;

export const UploadedFileWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-top: 8px;
    padding: 8px 12px;
    background-color: ${GRAY[50]};
    border-radius: 4px;
    border: 1px solid ${GRAY[200]};
`;

export const UploadedFileUrl = styled.div`
    font-size: 13px;
    color: ${GRAY[700]};
    word-break: break-all;
    flex: 1;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const AdditionalLoadingWrapper = styled(FLEX_COLUMN_DIV)`
    position:relative;
    top: 56px;

    & > button {
        border: 1px solid ${GRAY(20)};
        margin-top: 8px;
    }
`;